var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9092 10.0909C14.9637 11.1453 14.9637 12.8548 13.9092 13.9092C12.8548 14.9637 11.1453 14.9637 10.0909 13.9092C9.03644 12.8548 9.03644 11.1453 10.0909 10.0909C11.1453 9.03644 12.8548 9.03644 13.9092 10.0909",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25011 12C5.25011 12.297 5.27711 12.594 5.31311 12.882L3.72511 14.124C3.37311 14.4 3.27711 14.893 3.50111 15.28L4.91311 17.723C5.13611 18.11 5.61011 18.273 6.02511 18.107L7.44711 17.536C7.72811 17.423 8.04111 17.468 8.29311 17.635C8.51311 17.781 8.74111 17.915 8.97711 18.035C9.24711 18.172 9.44311 18.417 9.48611 18.717L9.70311 20.23C9.76611 20.672 10.1451 21 10.5911 21H13.4081C13.8541 21 14.2331 20.672 14.2961 20.23L14.5131 18.718C14.5561 18.418 14.7541 18.171 15.0251 18.035C15.2601 17.917 15.4871 17.784 15.7061 17.639C15.9601 17.471 16.2741 17.423 16.5561 17.537L17.9751 18.107C18.3891 18.273 18.8631 18.11 19.0871 17.723L20.4991 15.28C20.7231 14.893 20.6271 14.399 20.2751 14.124L18.6871 12.882C18.7231 12.594 18.7501 12.297 18.7501 12C18.7501 11.703 18.7231 11.406 18.6871 11.118L20.2751 9.876C20.6271 9.6 20.7231 9.107 20.4991 8.72L19.0871 6.277C18.8641 5.89 18.3901 5.727 17.9751 5.893L16.5561 6.463C16.2741 6.576 15.9601 6.529 15.7061 6.361C15.4871 6.216 15.2601 6.083 15.0251 5.965C14.7541 5.829 14.5561 5.582 14.5131 5.282L14.2971 3.77C14.2341 3.328 13.8551 3 13.4091 3H10.5921C10.1461 3 9.76711 3.328 9.70411 3.77L9.48611 5.284C9.44311 5.583 9.24611 5.829 8.97711 5.966C8.74111 6.086 8.51311 6.221 8.29311 6.366C8.04011 6.532 7.72711 6.577 7.44611 6.464L6.02511 5.893C5.61011 5.727 5.13611 5.89 4.91311 6.277L3.50111 8.72C3.27711 9.107 3.37311 9.601 3.72511 9.876L5.31311 11.118C5.27711 11.406 5.25011 11.703 5.25011 12V12Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingIcon);
export default __webpack_public_path__ + "static/media/setting-icon.1b6382c74d515144d91c5dce269569fe.svg";
export { ForwardRef as ReactComponent };